import { PartnerInline } from "./models";

export const partners: PartnerInline[] = [
  {
    title: "Coca Cola Foundation",
    image: {
      title: "Coca Cola Foundation",
      src: "/assets/partner/cocacola-logo.webp",
      width: 200,
      link: "https://coca-colacompany.com/",
    },
  },
  {
    title: "Kauno rajono savivaldybės administracija",
    image: {
      title: "Kauno rajono savivaldybės administracija",
      src: "/assets/partner/kauno-rajono-sav-administracija.png",
      link: "https://krs.lt/",
    },
  },
  {
    title: "Kauno miesto savivaldybės administracija",
    image: {
      title: "Kauno miesto savivaldybės administracija",
      src: "/assets/partner/kauno-miesto-sav-administracija.png",
      width: 183,
      link: "https://kaunas.lt/",
    },
  },
  {
    title: "Jaunimo reikalų agentūra",
    image: {
      title: "Jaunimo reikalų agentūra",
      src: "/assets/partner/jra-logo.png",
      link: "https://jra.lt/",
    },
  },
  {
    title: "Western Union",
    image: {
      title: "Western Union",
      src: "/assets/partner/western-union.png",
      width: 300,
      link: "https://westernunion.com/",
    },
  },
];
